/* eslint-disable import/prefer-default-export */
// Empresa
export const BUILDINGS = 1;
